import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {EntityKeyService} from '@pma-entity/services/entity-key.service';
import {EntityDataLayoutService} from "@layout/layouts/entity-data/entity-data-layout.service";
import {ListPageComponentBase} from "@mojo-mci/list-page-component-base";

@Component({
    selector: 'mojo-unit-list-page',
    templateUrl: './unit-list-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UnitListPageComponent
  extends ListPageComponentBase
  implements OnInit, OnDestroy {

  constructor(
    private readonly router: Router,
    entityKeyService: EntityKeyService,
    entityDataLayoutService: EntityDataLayoutService) {
    super(entityKeyService, entityDataLayoutService);
  }

  ngOnInit(): void {
    super.ngOnInit('Units');
  }

  handleRowSelect(data) {
    this.router.navigate([`/entity-data/property/${data['SystemPropertyRef']}/unit/${data['SystemUnitKeyRef']}`]);
  }

  getRowHref = (row) => {
    return `/entity-data/property/${row['SystemPropertyRef']}/unit/${row['SystemUnitKeyRef']}`;
  }
}
